"use client";
import {
  createHovercardStore
} from "../__chunks/TEVO2DMI.js";
import "../__chunks/MJ4ZJEIM.js";
import "../__chunks/7KNZCZ55.js";
import "../__chunks/IHNLLH3I.js";
import {
  createStore
} from "../__chunks/XTZ53NXG.js";
import {
  defaultValue
} from "../__chunks/UWJK2WK2.js";

// src/tooltip/tooltip-store.ts
function createTooltipStore(props = {}) {
  var _a;
  if (process.env.NODE_ENV !== "production") {
    if (props.type === "label") {
      console.warn(
        "The `type` option on the tooltip store is deprecated.",
        "Render a visually hidden label or use the `aria-label` or `aria-labelledby` attributes on the anchor element instead.",
        "See https://ariakit.com/components/tooltip#tooltip-anchors-must-have-accessible-names"
      );
    }
  }
  const syncState = (_a = props.store) == null ? void 0 : _a.getState();
  const hovercard = createHovercardStore({
    ...props,
    placement: defaultValue(
      props.placement,
      syncState == null ? void 0 : syncState.placement,
      "top"
    ),
    hideTimeout: defaultValue(props.hideTimeout, syncState == null ? void 0 : syncState.hideTimeout, 0)
  });
  const initialState = {
    ...hovercard.getState(),
    type: defaultValue(props.type, syncState == null ? void 0 : syncState.type, "description"),
    skipTimeout: defaultValue(props.skipTimeout, syncState == null ? void 0 : syncState.skipTimeout, 300)
  };
  const tooltip = createStore(initialState, hovercard, props.store);
  return {
    ...hovercard,
    ...tooltip
  };
}
export {
  createTooltipStore
};
